import React from "react";
import { useLanguage } from "../../context/LanguageContext";
import useReveal from "../../hooks/useReveal";

const Payments = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      id="payments"
      ref={ref}
      data-testid="payments-section"
      className="relative py-24 md:py-32 bg-[#070707] overflow-hidden"
    >
      {/* Radial gold glow background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-[radial-gradient(circle,rgba(232,212,168,0.08)_0%,transparent_60%)] pointer-events-none"></div>

      <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p
            className="reveal font-mono-l text-[11px] text-[#e8d4a8] mb-5 flex items-center justify-center gap-3"
            data-testid="payments-eyebrow"
          >
            <span className="w-6 h-px bg-[#e8d4a8]"></span>
            {t.payments.eyebrow}
            <span className="w-6 h-px bg-[#e8d4a8]"></span>
          </p>
          <h2
            className="reveal reveal-delay-1 font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] mb-6"
            data-testid="payments-title"
          >
            {t.payments.title}
          </h2>
          <p className="reveal reveal-delay-2 text-white/60 text-base md:text-lg font-light leading-relaxed">
            {t.payments.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-12">
          {t.payments.methods.map((m, i) => (
            <div
              key={i}
              className="reveal group relative p-8 md:p-10 border border-white/10 bg-black/40 backdrop-blur-xl card-hover text-center"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`payment-method-${i}`}
            >
              <div className="font-display text-[#e8d4a8] text-2xl md:text-[28px] mb-3 leading-tight group-hover:shimmer-text">
                {m.name}
              </div>
              <p className="font-mono-l text-[10px] text-white/50 leading-relaxed">
                {m.desc}
              </p>
            </div>
          ))}
        </div>

        <p
          className="reveal text-center text-white/50 text-sm font-light max-w-2xl mx-auto italic"
          data-testid="payments-note"
        >
          {t.payments.note}
        </p>
      </div>
    </section>
  );
};

export default Payments;
